var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "base-card",
        [
          _c("v-card-title", [_vm._v("Generación de Formatos")]),
          _c(
            "v-card-text",
            { staticClass: "line-text" },
            [
              _c(
                "v-row",
                { attrs: { justify: "center", "no-gutters": "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "5" } },
                    [
                      _c(
                        "v-form",
                        {
                          ref: "form",
                          model: {
                            value: _vm.formValid,
                            callback: function ($$v) {
                              _vm.formValid = $$v
                            },
                            expression: "formValid",
                          },
                        },
                        [
                          _c(
                            "v-row",
                            { attrs: { justify: "start" } },
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "12", sm: "4" } },
                                [
                                  _c("div", [_vm._v("Año:")]),
                                  _c("v-select", {
                                    ref: "year",
                                    attrs: {
                                      items: _vm.years,
                                      "item-text": "text",
                                      "item-value": "value",
                                      rules: [
                                        (v) => !!v || "El año es obligatorio",
                                      ],
                                      "prepend-inner-icon":
                                        "mdi mdi-calendar-range",
                                      required: "",
                                      dense: "",
                                      outlined: "",
                                    },
                                    model: {
                                      value: _vm.dataFilter.year,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.dataFilter, "year", $$v)
                                      },
                                      expression: "dataFilter.year",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", sm: "8" } },
                                [
                                  _c("div", [_vm._v("Formatos:")]),
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.filteredFormats,
                                      "item-text": "description",
                                      "item-value": "id",
                                      multiple: "",
                                      outlined: "",
                                      dense: "",
                                      rules: [
                                        (v) =>
                                          (v && v.length > 0) ||
                                          "Seleccione al menos un formato",
                                      ],
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        _vm.formatsList.length > 5
                                          ? {
                                              key: "prepend-item",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "v-list-item",
                                                    [
                                                      _c(
                                                        "v-list-item-content",
                                                        [
                                                          _c(
                                                            "v-list-item-title",
                                                            [
                                                              _c(
                                                                "v-text-field",
                                                                {
                                                                  attrs: {
                                                                    placeholder:
                                                                      "Buscar",
                                                                    "prepend-inner-icon":
                                                                      "mdi-magnify",
                                                                    "hide-details":
                                                                      "",
                                                                    dense: "",
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm.search,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.search =
                                                                          $$v
                                                                      },
                                                                    expression:
                                                                      "search",
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            }
                                          : null,
                                      ],
                                      null,
                                      true
                                    ),
                                    model: {
                                      value: _vm.dataFilter.formats,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.dataFilter, "formats", $$v)
                                      },
                                      expression: "dataFilter.formats",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "12", sm: "6" } },
                                [
                                  _c("div", [_vm._v("Fecha inicial:")]),
                                  _c(
                                    "v-dialog",
                                    {
                                      attrs: { persistent: "", width: "300px" },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "activator",
                                          fn: function ({ on, attrs }) {
                                            return [
                                              _c(
                                                "v-text-field",
                                                _vm._g(
                                                  _vm._b(
                                                    {
                                                      attrs: {
                                                        "prepend-inner-icon":
                                                          "mdi-calendar",
                                                        readonly: "",
                                                        outlined: "",
                                                        dense: "",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.dataFilter
                                                            .startDate,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.dataFilter,
                                                            "startDate",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "dataFilter.startDate",
                                                      },
                                                    },
                                                    "v-text-field",
                                                    attrs,
                                                    false
                                                  ),
                                                  on
                                                )
                                              ),
                                            ]
                                          },
                                        },
                                      ]),
                                      model: {
                                        value: _vm.modalStart,
                                        callback: function ($$v) {
                                          _vm.modalStart = $$v
                                        },
                                        expression: "modalStart",
                                      },
                                    },
                                    [
                                      _c("v-date-picker", {
                                        attrs: { max: _vm.dataFilter.endDate },
                                        on: {
                                          input: function ($event) {
                                            _vm.modalStart = false
                                          },
                                        },
                                        model: {
                                          value: _vm.dataFilter.startDate,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.dataFilter,
                                              "startDate",
                                              $$v
                                            )
                                          },
                                          expression: "dataFilter.startDate",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", sm: "6" } },
                                [
                                  _c("div", [_vm._v("Fecha final:")]),
                                  _c(
                                    "v-dialog",
                                    {
                                      attrs: { persistent: "", width: "300px" },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "activator",
                                          fn: function ({ on, attrs }) {
                                            return [
                                              _c(
                                                "v-text-field",
                                                _vm._g(
                                                  _vm._b(
                                                    {
                                                      attrs: {
                                                        "prepend-inner-icon":
                                                          "mdi-calendar",
                                                        readonly: "",
                                                        outlined: "",
                                                        dense: "",
                                                        disabled:
                                                          !_vm.dataFilter
                                                            .startDate,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.dataFilter
                                                            .endDate,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.dataFilter,
                                                            "endDate",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "dataFilter.endDate",
                                                      },
                                                    },
                                                    "v-text-field",
                                                    attrs,
                                                    false
                                                  ),
                                                  on
                                                )
                                              ),
                                            ]
                                          },
                                        },
                                      ]),
                                      model: {
                                        value: _vm.modalEnd,
                                        callback: function ($$v) {
                                          _vm.modalEnd = $$v
                                        },
                                        expression: "modalEnd",
                                      },
                                    },
                                    [
                                      _c("v-date-picker", {
                                        attrs: {
                                          min: _vm.dataFilter.startDate,
                                        },
                                        on: {
                                          input: function ($event) {
                                            _vm.modalEnd = false
                                          },
                                        },
                                        model: {
                                          value: _vm.dataFilter.endDate,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.dataFilter,
                                              "endDate",
                                              $$v
                                            )
                                          },
                                          expression: "dataFilter.endDate",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.showAlert || _vm.isLoading
                ? _c(
                    "v-row",
                    { staticClass: "my-4", attrs: { justify: "center" } },
                    [
                      _vm.isLoading
                        ? _c("v-progress-linear", {
                            staticClass: "my-4",
                            attrs: { color: "danger", indeterminate: "" },
                          })
                        : _vm._e(),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "6" } },
                        [
                          _vm.showAlert
                            ? _c(
                                "v-alert",
                                {
                                  staticClass: "my-4",
                                  attrs: {
                                    type: _vm.alertType,
                                    dense: "",
                                    outlined: "",
                                    border: "left",
                                    "colored-border": "",
                                  },
                                },
                                [_vm._v(" " + _vm._s(_vm.alertMessage) + " ")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "v-row",
                { attrs: { justify: "end", "no-gutters": "" } },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "text-sm-right",
                      attrs: { cols: "12", sm: "6" },
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "ma-2",
                          staticStyle: {
                            "background-color": "rgb(204 33 40)",
                            color: "white !important",
                          },
                          attrs: {
                            disabled: _vm.isLoading,
                            loading: _vm.isLoading,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.generateFormats()
                            },
                          },
                        },
                        [
                          _c("v-icon", { attrs: { left: "" } }, [
                            _vm._v("mdi mdi-creation-outline"),
                          ]),
                          _vm._v(" Generar "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-text",
            { staticClass: "mt-5 line-text" },
            [
              _c(
                "v-toolbar",
                { attrs: { flat: "", dense: "" } },
                [
                  _c("v-toolbar-title", [
                    _vm._v(" Tabla de formatos generados "),
                  ]),
                  _c("v-spacer"),
                  _c(
                    "v-tooltip",
                    {
                      attrs: { bottom: "" },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function ({ on, attrs }) {
                            return [
                              _c(
                                "v-btn",
                                _vm._g(
                                  _vm._b(
                                    {
                                      staticClass: "white--text border-button",
                                      attrs: {
                                        loading: _vm.loadingTable,
                                        disabled: _vm.loadingTable,
                                        color: "rgb(204 33 40)",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.getGeneratedFormats()
                                        },
                                      },
                                    },
                                    "v-btn",
                                    attrs,
                                    false
                                  ),
                                  on
                                ),
                                [_c("v-icon", [_vm._v("mdi-refresh")])],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [_c("span", [_vm._v("Refrescar tabla")])]
                  ),
                ],
                1
              ),
              _c("v-data-table", {
                staticClass: "elevation-1 mt-5",
                attrs: {
                  headers: _vm.headers,
                  items: _vm.dataTable,
                  search: _vm.searchTable,
                  loading: _vm.loadingTable,
                  "loading-text": "Cargando Formatos...",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: `item.statusDescription`,
                      fn: function ({ item }) {
                        return [
                          _c(
                            "v-chip",
                            {
                              staticClass: "white--text border-button px-4",
                              attrs: {
                                color: _vm.getStatusColor(
                                  item.statusDescription
                                ),
                                medium: "",
                              },
                            },
                            [_vm._v(" " + _vm._s(item.statusDescription) + " ")]
                          ),
                        ]
                      },
                    },
                    {
                      key: `item.creationDate`,
                      fn: function ({ item }) {
                        return [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "max-width": "250px",
                                "white-space": "nowrap",
                                overflow: "hidden",
                                "text-overflow": "ellipsis",
                              },
                            },
                            [_vm._v(" " + _vm._s(item.creationDate) + " ")]
                          ),
                        ]
                      },
                    },
                    {
                      key: `item.formatDescription`,
                      fn: function ({ item }) {
                        return [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "max-width": "250px",
                                "white-space": "nowrap",
                                overflow: "hidden",
                                "text-overflow": "ellipsis",
                              },
                            },
                            [_vm._v(" " + _vm._s(item.formatDescription) + " ")]
                          ),
                        ]
                      },
                    },
                    {
                      key: `item.fileName`,
                      fn: function ({ item }) {
                        return [
                          item.fileName != null
                            ? _c(
                                "v-btn",
                                {
                                  staticClass: "white--text border-button",
                                  attrs: { color: "rgb(36 24 213)" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.downloadFile(item.fileName)
                                    },
                                  },
                                },
                                [
                                  _c("v-icon", [
                                    _vm._v("mdi mdi-download-box"),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                    {
                      key: `item.dates`,
                      fn: function ({ item }) {
                        return [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "max-width": "250px",
                                "white-space": "nowrap",
                                overflow: "hidden",
                                "text-overflow": "ellipsis",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.formatDate(item.contentStartDate)
                                  ) +
                                  " - " +
                                  _vm._s(_vm.formatDate(item.contentEndDate)) +
                                  " "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                    {
                      key: `item.actions`,
                      fn: function ({ item }) {
                        return [
                          _c(
                            "v-btn",
                            {
                              staticClass: "white--text border-button",
                              attrs: { color: "rgb(204 33 40)" },
                              on: {
                                click: function ($event) {
                                  return _vm.deleteFormat(item.id)
                                },
                              },
                            },
                            [
                              _c("v-icon", [
                                _vm._v("mdi mdi-trash-can-outline"),
                              ]),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-overlay",
        { attrs: { value: _vm.loading, absolute: "", opacity: "0.6" } },
        [
          _c("v-progress-circular", {
            attrs: { indeterminate: "", size: "64", color: "rgb(204 33 40)" },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }